export default __webpack_public_path__ + "static/media/icon-footer-youtube.cd97da45.svg";